import { render, staticRenderFns } from "./KeywordDetails.vue?vue&type=template&id=1e04328e&scoped=true&"
import script from "./KeywordDetails.vue?vue&type=script&lang=ts&"
export * from "./KeywordDetails.vue?vue&type=script&lang=ts&"
import style0 from "./KeywordDetails.vue?vue&type=style&index=0&id=1e04328e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e04328e",
  null
  
)

export default component.exports